
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import moment from 'moment';
    import Lagerbuchungsart from '@/types/Lagerbuchungsart';
    import { BuchungsprotkollFilter } from '@/store/lagerfuehrung';
    import { DataTableHeaders } from '@/types';
    import Lagerbuchung from '@/types/Lagerbuchung';
    import Patient from '@/types/Patient';

    @Component({
        computed: {
            ...mapState('authentication', ['user']),
            ...mapState('patient', ['patientData']),
            ...mapState('lagerfuehrung', [
                'loaders',
                'filters',
                'lagerbuchungen',
                'selected_impfstoff',
                'lagerbuchungsarten',
            ]),
        },
        methods: {
            ...mapActions('lagerfuehrung', [
                'getLagerbuchungen',
                'loadLagerbuchungsarten',
                'exportLagerbuchungen',
            ]),
            ...mapActions('patient', ['loadPatient']),
        },
    })
    export default class Buchungsprotokoll extends Vue {
        @Prop() visible!: boolean;

        public lagerbuchungsarten!: Lagerbuchungsart[];
        public loadLagerbuchungsarten!: () => void;
        public getLagerbuchungen!: (payload?: BuchungsprotkollFilter) => void;
        public patientData!: Patient | null;
        public loadPatient!: (payload: { patnr: number }) => Promise<void>;

        public filter: BuchungsprotkollFilter = {
            von: moment().format('YYYY-MM-DD'),
            bis: moment().format('YYYY-MM-DD'),
            alleImpfstellen: false,
        };

        public get headers(): DataTableHeaders<Lagerbuchung, 'fw_created_user' | 'patient'> {
            return [
                { text: 'Zeitpunkt', value: 'zeitpunkt', width: 150 },
                /*{ text: 'Impfstelle', value: 'impfstelleDisplay' },*/
                { text: 'Benutzer', value: 'fw_created_user' },
                { text: 'Art', value: 'lagerbuchungsart' },
                { text: 'Impfstoff', value: 'impfstoff_impfstoff' },
                { text: 'Chargenr.', value: 'impfstoffcharge_charge' },
                { text: 'Anzahl', value: 'anzahl' },
                { text: 'Patient', value: 'patient' },
                { text: 'Anmerkung', value: 'anmerkung' },
            ];
        }

        public onClickPatient(patnr: number): void {
            this.$emit('close');
            this.$router.push('/');

            if (this.patientData?.patnr === patnr) {
                return;
            }

            this.loadPatient({ patnr });
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.filter = {
                    von: moment().format('YYYY-MM-DD'),
                    bis: moment().format('YYYY-MM-DD'),
                    alleImpfstellen: false,
                };

                if (this.lagerbuchungsarten.length === 0) {
                    this.loadLagerbuchungsarten();
                }

                this.getLagerbuchungen(this.filter);
            }
        }
    }
